import { routes } from "../../common/routes/routes";
import { usePermissionsChecker } from "../../core/auth/Permissions";
import { Permission } from "../../core/common-types/permission.enum";
import { NavBarBase } from "../../layout/nav-bar/components/NavBarBase";
import { NavBarNavItem } from "../../layout/nav-bar/components/NavbarNavItem";

export const LegacyNavBar = () => {
  const hasPermission = usePermissionsChecker();
  const hasBpMWebPermission = hasPermission(Permission.ProsBpmWebAllowed);

  return (
    <NavBarBase
      beforeNavButtons={
        <>
          <NavBarNavItem
            to={routes.appointmentBooking.locationEdit.path}
            text={routes.appointmentBooking.locationEdit.text}
            iconName="Settings"
          />
          {hasBpMWebPermission && (
            <NavBarNavItem
              text="Jump to ..."
              items={[
                routes.bpMobileDashboard.basePath,
                routes.bpMobileBooking.appointments,
                routes.bpMobileAddressBook.patients,
                routes.bpMobileTodo.userInbox
              ]}
            />
          )}
        </>
      }
    />
  );
};
